import React, { useCallback } from "react";

import CaptureDropZone from "../Capture/components/CaptureDropZone";
import { useCaptureSegmentDrop } from "./CaptureSegmentDropContext";

/**
 * BuilderCaptureDropZone — the builder canvas AS A DROP TARGET.
 *
 * Wraps the open Segment's canvas so a capture dragged out of the Captured
 * drawer lands at the bottom of that Segment. The drop always goes to the
 * Segment currently on the canvas — a drag has no way to name a different one,
 * and inventing a target would be the silent wrong-Segment write this feature
 * is careful to avoid. Choosing a different Segment is what the picker is for.
 *
 * When no Segment is open there is nowhere to drop, so the zone REFUSES
 * VISIBLY (`canAccept={false}` renders the reason over the canvas) instead of
 * accepting a drag that would then do nothing. Kelly's recorded attempt produced
 * no ghost, no highlight and no message at all, and that silence is why the same
 * bug was reported three times.
 *
 * Flag OFF: `isEnabled` false makes CaptureDropZone return its children
 * verbatim — no wrapper element, no listeners, no layout change.
 */
const BuilderCaptureDropZone = ({ children }) => {
  const { isEnabled, activeSegmentId, place } = useCaptureSegmentDrop();

  const handleDropCapture = useCallback(
    (item) => place(item, activeSegmentId),
    [place, activeSegmentId],
  );

  return (
    <CaptureDropZone
      isEnabled={isEnabled}
      canAccept={activeSegmentId !== null && activeSegmentId !== undefined}
      refusalMessage="Open a Segment first, then drop the capture into it."
      onDropCapture={handleDropCapture}
    >
      {children}
    </CaptureDropZone>
  );
};

export default BuilderCaptureDropZone;
